// ─── Groups & Teams Activity Dashboard Constants ─────────

export const COLORS = {
    primary: '#206FA5',
    primaryLight: '#EBF2FA',
    blue: '#206FA5',
    blueLight: '#DBEAFE',
    blueDark: '#1E40AF',
    amber: '#D97706',
    amberLight: '#FEF3C7',
    amberDark: '#92400E',
    amberHover: '#FDE68A',
    green: '#10B981',
    yellow: '#F59E0B',
    red: '#EF4444',
    gray: '#D1D5DB',
    grayLight: '#F3F4F6',
    // CVS feedback (Jun 2026): the original grays (#8A94A6 / #6B7A90) were too
    // light to read — both failed WCAG AA 4.5:1 contrast on white.
    grayMedium: '#64748B',
    grayDark: '#475569',
    textPrimary: '#1a1a2e',
    textSecondary: '#4A5568',
    border: '#E8ECF0',
    borderLight: '#F3F4F6',
    cardBg: '#ffffff',
    pageBg: '#F5F7FA',

    // Chart bar colors
    barDefault: '#93C5FD',
    barMedium: '#60A5FA',
    barHigh: '#3B82F6',
    barCurrent: '#206FA5',

    // Feature chart colors
    featureCheckOnMe: '#206FA5',
    featureSafetyReports: '#10B981',
    featureFakeCall: '#60A5FA',
    featureRiskReviews: '#F59E0B',
    featureSOS: '#EF4444',
} as const;

export const TIME_PERIOD_OPTIONS = [
    { label: 'Last 7 Days', value: '7d' },
    { label: 'Last 14 Days', value: '14d' },
    { label: 'Last 30 Days', value: '30d' },
    { label: 'Last 60 Days', value: '60d' },
    { label: 'Last 90 Days', value: '90d' },
    { label: 'Last 6 Months', value: '6m' },
    { label: 'Last 12 Months', value: '12m' },
    { label: 'Custom Range', value: 'custom' },
] as const;

export const FEATURE_NAMES = [
    'Check On Me',
    'Field Safety Reports',
    'Fake Call',
    'Risk Reviews',
    'SOS Alert',
] as const;

export const ACTIVE_THRESHOLD = {
    high: 20,    // >= 20% = blue dot
    medium: 10,  // >= 10% = green dot
    low: 1,      // >= 1% = yellow dot
    // 0% = red dot
} as const;

export const L2_PAGE_SIZE = 20;

export const getActiveColor = (percent: number): string => {
    if (percent >= ACTIVE_THRESHOLD.high) return COLORS.blue;
    if (percent >= ACTIVE_THRESHOLD.medium) return COLORS.green;
    if (percent >= ACTIVE_THRESHOLD.low) return COLORS.yellow;
    return COLORS.red;
};

export const getActiveBarClass = (percent: number): string => {
    if (percent >= ACTIVE_THRESHOLD.high) return COLORS.blue;
    if (percent >= ACTIVE_THRESHOLD.medium) return COLORS.green;
    if (percent >= ACTIVE_THRESHOLD.low) return COLORS.yellow;
    return COLORS.red;
};
